export enum DASHBOARD_TYPE {
  ADMIN = "admin",
  BUSINESS = "business",
}
